import { render } from "./HeaderVideoPreview.vue?vue&type=template&id=5a527008&scoped=true"
import script from "./HeaderVideoPreview.vue?vue&type=script&lang=js"
export * from "./HeaderVideoPreview.vue?vue&type=script&lang=js"

import "./HeaderVideoPreview.vue?vue&type=style&index=0&id=5a527008&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a527008"]])

export default __exports__